import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\TaskDossier\BulkDeleteTaskDossierController::__invoke
* @see app/Http/Controllers/TaskDossier/BulkDeleteTaskDossierController.php
* @route '/api/task-dossier/bulk-delete'
*/
const BulkDeleteTaskDossierController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: BulkDeleteTaskDossierController.url(options),
    method: 'post',
})

BulkDeleteTaskDossierController.definition = {
    methods: ["post"],
    url: '/api/task-dossier/bulk-delete',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\TaskDossier\BulkDeleteTaskDossierController::__invoke
* @see app/Http/Controllers/TaskDossier/BulkDeleteTaskDossierController.php
* @route '/api/task-dossier/bulk-delete'
*/
BulkDeleteTaskDossierController.url = (options?: RouteQueryOptions) => {
    return BulkDeleteTaskDossierController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\TaskDossier\BulkDeleteTaskDossierController::__invoke
* @see app/Http/Controllers/TaskDossier/BulkDeleteTaskDossierController.php
* @route '/api/task-dossier/bulk-delete'
*/
BulkDeleteTaskDossierController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: BulkDeleteTaskDossierController.url(options),
    method: 'post',
})

export default BulkDeleteTaskDossierController